// extracted by mini-css-extract-plugin
module.exports = {"blogTag":"styles_blogTag__1-D47","tagsContainer":"styles_tagsContainer__36ZkO","summary":"styles_summary__thoRq"};